import * as yup from 'yup';
import { z } from 'zod';

import { FEIN_LENGTH } from '@clearverify/constants';

import { clearFein } from 'src/utils/fein';

export const feinValidationSchema = yup
  .string()
  .trim()
  .min(FEIN_LENGTH)
  .test('fein', (value, context) => {
    if (!value) return false;
    const numericFein = clearFein(value);
    if (numericFein && numericFein.length !== FEIN_LENGTH) {
      return context.createError({ message: 'Invalid FEIN' });
    }
    return true;
  });

export const feinZodValidationSchema = z
  .string()
  .trim()
  .min(FEIN_LENGTH)
  .refine(
    value => {
      if (!value) return false;
      const numericFein = clearFein(value);
      if (numericFein && numericFein.length !== FEIN_LENGTH) {
        return false;
      }
      return true;
    },
    { error: 'Invalid FEIN' },
  );
